import React, { useRef } from 'react'
import { MessageSwitchProps } from '../MessageSwitch'
import { MessageWrapper } from './MessageWrapper'
import classNames from 'classnames'
import {
  MessageLivechatEnd,
  MessageLivechatStart,
  MessageUnread,
} from '~/service/chatConn/types'

export type TextAnswerProps = MessageSwitchProps<
  MessageUnread | MessageLivechatStart | MessageLivechatEnd
>

const HorizontalLine: React.FC<TextAnswerProps> = ({ ...props }) => {
  const { message } = props

  const ref = useRef<HTMLDivElement>(null)

  return (
    <>
      <MessageWrapper
        {...props}
        className={classNames('is-horizontalLine', {
          'is-unread': message.type == 'UNREAD',
          'is-livechatStartEnd': ['LIVECHAT_START', 'LIVECHAT_END'].includes(
            message.type
          ),
        })}
        _ref={ref}
      >
        <div>
          <div></div>
          <div>
            {message.type == 'UNREAD'
              ? intl.formatMessage({ id: 'chat / output / unread messages' })
              : message.type == 'LIVECHAT_START'
              ? intl.formatMessage({ id: 'chat / output / livechat start' })
              : intl.formatMessage({ id: 'chat / output / livechat end' })}
          </div>
          <div></div>
        </div>
      </MessageWrapper>
    </>
  )
}

export default HorizontalLine
